function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import clsx from 'clsx';
import { node, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import SovosTypography from '../sovos-typography';
const Root = styled(SovosTypography)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  return {
    alignItems: 'center',
    color: palette.primary.contrastText,
    display: 'flex',
    height: spacing(7.5),
    paddingBottom: spacing(),
    paddingTop: spacing(4)
  };
});

/**
 * **Note** Must be a child `SovosHeroBanner`
 */
const SovosHeroBannerTitle = _ref2 => {
  let {
    children,
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Root, _extends({
    className: clsx('sovosHeroBannerTitle', className),
    variant: "h2"
  }, rest), children);
};
SovosHeroBannerTitle.propTypes = {
  /**
   * The content of the hero hero banner title
   */
  children: node,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
export default SovosHeroBannerTitle;